
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import UserSvg from './svg/UserSvg.vue';

export default defineComponent({
  name: 'UserIcon',
  components: {
    Icon
  },
  data() {
    return {
      UserSvg: markRaw(UserSvg)
    };
  }
});
